import { useEffect, useRef, useState } from "react";
import { useToken } from "../../../../components/useToken";
import { useLazyParams } from "../../../../hooks/useLazyParams";
import { ProveedorPj } from "../../../../models/trust/proveedorPj/proveedorPj";
import { ProveedorPjService } from "../../../../service/trust/ProveedorPjService";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import * as generic from '../../../../components/Generico';
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Menu } from "primereact/menu";
import { Toolbar } from "primereact/toolbar";
import { Card } from "primereact/card";
import { TablaDinamica } from "../../../../components/TablaDinamica";
import { Panel } from "primereact/panel";
import { TabPanel, TabView } from "primereact/tabview";
import { InfoGeneral } from "../proveedorPj/Secciones/InfoGeneral";
import { PatrimonioActividad } from "./Secciones/PatrimonioActividad";
import { InformacionReferencias } from "./Secciones/InformacionReferencias";
import { Declaracion } from "./Secciones/Declaracion";
import { Dialog } from "primereact/dialog";
import { AnexosComponent } from '../../../../components/AnexosComponent';
import { DialogInstrucciones } from "../../../../components/ui/DialogInstrucciones";

export const InfoProveedorPj = () => {
    const [catalogos, setCatalogos] = useState(null);
    const omodel = new ProveedorPj({ formularioMatriz: catalogos?.formularioMatriz });
    const toast = useRef(null);
    const proveedorServicio = new ProveedorPjService();
    const { getPerss, getRol } = useToken();
    // Estados Globales del Formulario
    const [proveedor, setProveedor] = useState(null);    
    const [permss, setPermss] = useState(null);
    // Estados de navegación y UI
    const [dialogProveedor, setDialogProveedor] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);
    const [siCliente, setSiCliente] = useState(false);
    const [urls, setUrls] = useState(null);
    const [dialogAnexos, setDialogAnexos] = useState(false);
    const tablaEstado = useLazyParams({ modelo: omodel.model });
    const menuRef = useRef(null);
    const topRef = useRef(null);
    const [mostrarRegresarFlotante, setMostrarRegresarFlotante] = useState(false);
    const [dialogInstruccion, setDialogInstruccion] = useState(false);
    const [soloLectura, setSoloLectura] = useState(false);
    const [opcion, setOpcion] = useState(null);

    useEffect(() => {
        setUrls({
            urlListado: 'ficha/trust/proveedor-pj',
            urlDownload: 'ficha/trust/proveedor-pj/descarga',
            urlUpload: 'ficha/trust/proveedor-pj/store',
            udelete: 'ficha/trust/proveedor-pj/eliminar-anexo',
            uactual: 'ficha/trust/proveedor-pj/editar',
            uenviar: 'ficha/trust/proveedor-pj/enviar',
            uaprobar: 'ficha/trust/proveedor-pj/aprobar',
        });

        const permisosToken = getPerss();
        const esClienteNotificado = permisosToken !== undefined; // Si tiene perss en el token es notificado
        setSiCliente(esClienteNotificado);
        if (esClienteNotificado) {
            setPermss(permisosToken);
            editFicha(true);
        }
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        const esClienteNotificado = getPerss() !== undefined;
        if (!esClienteNotificado) {
            loadLazyData();
        }
        // eslint-disable-next-line
    }, [tablaEstado.lazyParams]);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                setMostrarRegresarFlotante(!entry.isIntersecting);
            },
            { threshold: 0 }
        );
        const currentRef = topRef.current;
        if (currentRef) {
            observer.observe(currentRef);
        }
        return () => {
            if (currentRef) {
                observer.unobserve(currentRef);
            }
        };
    }, [dialogProveedor]);


    const loadLazyData = () => {
        tablaEstado.setLoading(true);
        let _lazyParams = { ...tablaEstado.lazyParams };
        delete _lazyParams.rtipo;
        if (permss == null) {
            _lazyParams.rtipo = true;
        }
        const rol = getRol();
        if (!rol) {
            toast.current.show({ severity: 'warn', summary: 'Rol no seleccionado', detail: 'Por favor selecciona un rol antes de continuar.', life: 3000 });
            tablaEstado.setLoading(false);
            return;
        } else {
            _lazyParams.rol = rol;
        }
        proveedorServicio.getLista({ lazyEvent: JSON.stringify(_lazyParams) }).then(res => {
            tablaEstado.setTotalRecords(res.data.total);
            tablaEstado.setData(res.data.registros);
            if (res.data.perss !== undefined) {
                setPermss(res.data.perss);
                setOpcion(res.data.opcion);
            }
            if (res.data.cats) {
                setCatalogos(res.data.cats);
            }
        }).finally(() => {
            tablaEstado.setLoading(false);
        });
    }

    const iniciarNuevo = () => {
        setSoloLectura(false);
        setDialogProveedor(true);
        setProveedor(null);
        setActiveIndex(0);
        setDialogInstruccion(true);
    }

    const editFicha = (esNotificado = false, isReadOnly = false) => {
        setSoloLectura(isReadOnly);
        const idConsulta = esNotificado ? 0 : proveedor?.id;
        const necesitaCatalogos = catalogos === null;

        proveedorServicio.consultarProveedor(idConsulta, { necesitaCatalogos: necesitaCatalogos }).then(res => {
            if (necesitaCatalogos && res.data.catalogos) {
                setCatalogos(res.data.catalogos);
            }
            if (!res.data.proveedor) {
                iniciarNuevo();
                return;
            }
            setDialogProveedor(true);
            setActiveIndex(0);
            setDialogInstruccion(true);

            nuevoProveedor({
                id: res.data.proveedor.id,
                nemonico: res.data.proveedor.nemonico,
            });
        }).finally(() => {

        });
    }

    const confirmDelete = () => {
        confirmDialog({
            message: '¿Está seguro de eliminar el formulario?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => deleteProveedor()
        });
    }

    const deleteProveedor = () => {
        proveedorServicio.eliminarProveedor(proveedor.id).then(res => {
            loadLazyData();
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcDeleteError(error, toast);
        });
    }

    const nuevoProveedor = (nuevo) => {
        const _prov = proveedor ?? {};
        if (nuevo) {
            if (nuevo?.id !== undefined) _prov.id = nuevo.id;
            if (nuevo?.nemonico !== undefined) _prov.nemonico = nuevo.nemonico;
        }
        setProveedor(Object.keys(_prov).length === 0 ? null : _prov);
    }

    const handleNext = () => { if (activeIndex < 3) setActiveIndex(activeIndex + 1); };
    const handlePrev = () => { if (activeIndex > 0) setActiveIndex(activeIndex - 1); };

    const regresar = () => {
        setActiveIndex(0);
        setDialogProveedor(false);
        setSoloLectura(false);
        if (!siCliente) loadLazyData();
    }

    const reiniciar = () => {
        if (!siCliente) loadLazyData();
        setDialogProveedor(false);
        setDialogAnexos(false);
    }

    const itemsMenu = () => {
        const items = [];
        if (permss?.consultar) {
            items.push({ label: 'Ver', icon: 'pi pi-eye', command: () => { editFicha(false, true); } });
        }
        if (permss?.actualizar && (proveedor?.nemonico === 'BORRADOR' || proveedor?.nemonico === 'ENVIADO')) {
            items.push({ label: 'Editar', icon: 'pi pi-pencil', command: () => { editFicha() } });
        }
        if (permss?.consultar) items.push({ label: 'Anexos formulario', icon: 'pi pi-folder-open', command: () => { setDialogAnexos(true) } });
        if (permss?.eliminar && proveedor?.nemonico === 'BORRADOR') {
            items.push({ label: 'Eliminar', icon: 'pi pi-trash', command: () => { confirmDelete() } });
        }
        return [{ label: 'Opciones', items: items }];
    }

    const accionesTemplate = (rowData) => {
        return (
            <Button icon="pi pi-caret-down" type="button" className="p-button-rounded p-button-success mr-2" title="Opciones/Acciones" aria-controls="popup_menu" aria-haspopup
                onClick={(event) => { setProveedor(rowData); menuRef.current.toggle(event); }} />
        );
    };

    const ColumnaAcciones = (
        <Column header="Acciones" body={accionesTemplate} style={{ width: '6rem', textAlign: 'center' }} />
    );

    const panelHeaderTemplate = (options) => (
        <div className="p-panel-header flex justify-content-between align-items-center flex-wrap gap-2 w-full">
            <div>
                <h3 className="m-0 text-xl font-bold p-text-secondary flex align-items-center">
                    <i className="pi pi-building mr-2"></i>
                    <span className="mr-2">{proveedor?.id ? 'EDITAR' : 'NUEVO'} FORMULARIO DE INFORMACIÓN DEL PROVEEDOR (PJ)</span>
                    <Button type="button" icon="pi pi-question-circle" className="p-button-rounded p-button-text p-button-sm p-0 m-0 text-white hover:text-blue-200 transition-colors transition-duration-200"
                        style={{ width: '2rem', height: '2rem' }} onClick={() => setDialogInstruccion(true)} tooltip="Ver instrucciones" tooltipOptions={{ position: 'right' }} />
                </h3>
            </div>
            {!siCliente && (
                <Button tooltip="Regresar al listado" tooltipOptions={{ position: 'left' }} icon="pi pi-arrow-left" onClick={regresar} />
            )}
        </div>
    );

    return (
        <>
            <ConfirmDialog className="dialog-personalizado" />
            <Toast ref={toast} />
            <Menu model={itemsMenu()} popup ref={menuRef} id="popup_menu" />
            {!dialogProveedor && !siCliente && (
                <div className="fadein animation-duration-300">
                    <Toolbar className="mb-4 shadow-1 border-round" start={generic.leftToolbarTemplate(iniciarNuevo, '', permss)} end={generic.rightToolbarTemplate(tablaEstado.data, omodel, 'Listado_proveedor_pj', 'LISTADO INFORMACIÓN PROVEEDOR PJ')} />
                    <Card style={{ maxWidth: '100%', margin: 'auto' }}>
                        <TablaDinamica modelo={omodel.model} estadoTabla={tablaEstado} datos={tablaEstado.data} totalRegistros={tablaEstado.totalRecords} dataKey="id" acciones={ColumnaAcciones} />
                    </Card>
                </div>
            )}
            {dialogProveedor &&
                <div className="fadein animation-duration-300">
                    <Panel headerTemplate={panelHeaderTemplate} className="panel-ficha shadow-2">
                        <div ref={topRef} style={{ position: 'absolute', top: '0', left: '0', width: '1px', height: '80px', pointerEvents: 'none', visibility: 'hidden' }} />
                        <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} className="form-tabview">
                            <TabPanel header="Sección 1" leftIcon="pi pi-id-card mr-2" disabled={proveedor == null}>
                                <InfoGeneral handleNext={handleNext} handlePrev={handlePrev}
                                    permss={permss} proveedor={proveedor} catalogos={catalogos} toast={toast}
                                    nuevoProveedor={nuevoProveedor} id={proveedor?.id} soloLectura={soloLectura} />
                            </TabPanel>

                            <TabPanel header="Sección 2" leftIcon="pi pi-users mr-2" disabled={!proveedor?.id}>
                                <PatrimonioActividad handleNext={handleNext} handlePrev={handlePrev}
                                    permss={permss} proveedor={proveedor} catalogos={catalogos} toast={toast}
                                    nuevoProveedor={nuevoProveedor} id={proveedor?.id} soloLectura={soloLectura} />
                            </TabPanel>

                            <TabPanel header="Sección 3" leftIcon="pi pi-shield mr-2" disabled={!proveedor?.id}>
                                <InformacionReferencias handleNext={handleNext} handlePrev={handlePrev}
                                    permss={permss} proveedor={proveedor} catalogos={catalogos} toast={toast}
                                    nuevoProveedor={nuevoProveedor} id={proveedor?.id} soloLectura={soloLectura} />
                            </TabPanel>

                            <TabPanel header="Sección 4" leftIcon="pi pi-file-check mr-2" disabled={!proveedor?.id}>
                                <Declaracion handleNext={handleNext} handlePrev={handlePrev}
                                    permss={permss} proveedor={proveedor} catalogos={catalogos} toast={toast}
                                    nuevoProveedor={nuevoProveedor} id={proveedor?.id} siCliente={siCliente} urls={urls}
                                    setDialogProveedor={setDialogProveedor} setDialogAnexos={setDialogAnexos} loadLazyData={loadLazyData}
                                    reiniciar={reiniciar} soloLectura={soloLectura} />
                            </TabPanel>
                        </TabView>
                    </Panel>

                    {mostrarRegresarFlotante && !siCliente && (
                        <div className="fadein scalein" style={{ position: 'fixed', top: '65px', right: '30px', zIndex: 999 }}>
                            <Button icon="pi pi-arrow-left" onClick={regresar} rounded className="p-button-primary shadow-4" style={{ width: '45px', height: '45px' }} tooltip="Regresar al listado" tooltipOptions={{ position: 'left' }} />
                        </div>
                    )}
                </div>
            }

            <DialogInstrucciones visible={dialogInstruccion} onHide={() => setDialogInstruccion(false)} title={omodel.titulo} items={omodel.pasosInstrucciones} />
            <Dialog visible={dialogAnexos} header="Gestión de Anexos" modal className="p-fluid modal-ssize dialog-personalizado" onHide={() => setDialogAnexos(false)} style={{ width: '800px' }}>
                <AnexosComponent tipo="proveedorPjTf" urls={urls} idp={proveedor?.id} toast={toast} permss={permss} setDialogSubir={setDialogAnexos} reiniciar={reiniciar} 
                    estado={proveedor?.nemonico} soloLectura={soloLectura} opcion={opcion} />
            </Dialog>
        </>
    )
}